import React from 'react'
import {Link} from 'react-router-dom'

const LogoAndLinks = ({t, children}) => (
  <>
    <div id='nav-topBar'>
      <div>
        <Link to='/about-us'>{t('ABOUT US')}</Link>
        <Link to='/about-us'>{t('HOW DOES IT WORK')}</Link>
        <Link to='/about-us'>{t('TRADE PERSON')}</Link>
      </div>
    </div>

    <div id='nav-mainNav'>
      <div>
        {children}
      </div>
    </div>

    <div id='nav-logo'><Link to='/'/></div>
  </>
)

export default LogoAndLinks
